// extracted by mini-css-extract-plugin
module.exports = {"spin-wrapper":"_4d7ec41daeb4dc550f3a185d06846f4c-less","spinWrapper":"_4d7ec41daeb4dc550f3a185d06846f4c-less","image":"a1580c9cce5d68a9d85eb7592f40c6f6-less"};